<template>
  <div class="modalWrap" :style="{ zIndex: zIndex, display: display }">
    <modal
      :adaptive="true"
      :name="modalName"
      class="base-modal-inner js-base-modal-inner relative modal"
      @before-open="beforeOpen"
      @opened="onModalOpened"
      @before-close="beforeClose"
      @closed="onModalClosed"
    >
      <button class="modal__close" @click="closeModal">
        <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
          <rect width="32" height="32" rx="16" fill="#6C7073"/>
          <path d="m11 11 10 10m0-10L11 21" stroke="#fff" stroke-width="1.5" stroke-linejoin="round"/>
        </svg>
      </button>
      <div class="modal__content">
        <slot></slot>
      </div>
    </modal>
  </div>
</template>

<script>
  import Vue from 'vue'
  import vmodal from 'vue-js-modal'
  import { disableBodyScroll, clearAllBodyScrollLocks } from '@/assets/js/lock-scroll'
  Vue.use(vmodal)

  export default {
    name: 'ModalComponent',

    props: {
      modalName: {
        type: String,
        required: true
      }
    },
    data() {
      return {
        zIndex: 9999,
        display: 'none'
      };
    },

    watch: {
      '$route' () {
        this.closeModal()
      },
      modalValue (val) {
        this.$parent.$emit('modal-change', val)
      }
    },

    methods: {
      beforeOpen (event) {
        const el = this.$refs.target || this.$el
        disableBodyScroll(el)
      },
      onModalOpened() {
        this.zIndex = 9999;
        this.display = 'block';
      },
      closeModal () {
        this.$modal.hide(this.modalName)
      },
      beforeClose () {
        clearAllBodyScrollLocks()
      },
      onModalClosed () {
        this.$emit('modal-closed')
      }
    }
  }
</script>

<style lang="scss">
.v--modal-background-click {
  background: rgba(0, 0, 0, 0.87);
}

.modalWrap {
  position: fixed;
  left: 0;
  top: 0;

  @media (max-width: 767px) {
    width: 100%;
  }
}

.modal {
  display: flex;
  flex-direction: column;
  align-items: center;

  .vm--modal {
    width: 710px !important;
    height: min-content !important;

    @media (max-width: 767px) {
      max-width: 90%;
      left: 0 !important;
    }
  }

  &-inner {
    position: relative;
    max-height: 90vh;
    margin: 0 24px;
    z-index: 99999;

    @include mobile {
      max-width: none;
      margin: 0 auto;
    }
  }

  &__content {
    padding: 40px 40px 40px 40px;
    font-family: "ToyotaType", Arial, Helvetica, sans-serif;
    font-size: 20px;
    text-align: left;

    @include mobile {
      font-size: 16px;

      img {
        max-width: 100%;
      }
    }
  }
}

.modal__close {
  height: 32px;
  width: 32px;
  position: absolute;
  top: 24px;
  right: 24px;
  z-index: 5;
  cursor: pointer;
  padding: 0;
  background: unset;
  border: unset;

  &:hover {
    cursor: pointer;
  }

  svg {
    width: 32px;
    height: 32px;
  }

  @include mobile {
    top: 8px;
    right: 8px;
  }
}
</style>
